import {Component, OnInit} from '@angular/core';

import {TipoEstablecimiento} from '../../../models/tipo-establecimiento.model';
import {CatalogosService} from '../../../services/catalogos.service';

@Component({
  templateUrl: './listado-tipos-establecimientos.component.html',
  styleUrls: ['./listado-tipos-establecimientos.component.css']
})
export class ListadoTiposEstablecimientosComponent implements OnInit {

  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio'
    },
    {
      label: 'Establecimientos',
      routerLink: '/establecimientos'
    }
  ];

  tipos: TipoEstablecimiento[];
  loading = false;

  constructor(private catalogosService: CatalogosService) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getTiposEstablecimientos().subscribe((tipos) => {
      this.loading = false;
      this.tipos = tipos;
    });
  }
}
